import { render, staticRenderFns } from "./BatchesDashboard.vue?vue&type=template&id=1bf4b41f&"
import script from "./BatchesDashboard.vue?vue&type=script&lang=js&"
export * from "./BatchesDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports